import React, { useEffect, useState, Children } from 'react';
import { Link, NavLink, useLocation } from 'react-router-dom';
import { MenuIcon, XIcon, ChevronDownIcon } from 'lucide-react';
import { motion, AnimatePresence } from 'framer-motion';
import { Logo } from '../ui/Logo';
import { Button } from '../ui/Button';
interface NavItem {
  label: string;
  to: string;
  children?: {
    label: string;
    to: string;
  }[];
}
const navItems: NavItem[] = [{
  label: 'HOME',
  to: '/en'
}, {
  label: 'ABOUT',
  to: '/en/about',
  children: [{
    label: 'Who We Are',
    to: '/en/about#who-we-are'
  }, {
    label: 'Vision & Mission',
    to: '/en/about#vision-mission'
  }, {
    label: 'Why Non-Muslim Countries',
    to: '/en/about#why-non-muslim-countries'
  }, {
    label: 'Governance & Transparency',
    to: '/en/about#governance'
  }, {
    label: 'Leadership & Team',
    to: '/en/about#leadership-team'
  }]
}, {
  label: 'CHILDREN',
  to: '/en/children',
  children: [{
    label: 'For Children',
    to: '/en/children'
  }, {
    label: 'Kids Programs',
    to: '/en/children/kids-programs'
  }, {
    label: 'Online Learning',
    to: '/en/children/online-learning'
  }, {
    label: 'Values & Identity',
    to: '/en/children/values-identity'
  }, {
    label: 'Scholarships',
    to: '/en/children/scholarships'
  }]
}, {
  label: 'PARENTS',
  to: '/en/parents',
  children: [{
    label: 'For Parents',
    to: '/en/parents'
  }, {
    label: 'Membership',
    to: '/en/parents/membership'
  }, {
    label: 'Parenting in Non-Muslim Countries',
    to: '/en/parents/parenting-in-non-muslim-countries'
  }, {
    label: 'Preventing Discrimination',
    to: '/en/parents/preventing-discrimination'
  }, {
    label: 'Resources & Guidance',
    to: '/en/parents/resources-guidance'
  }]
}, {
  label: 'ADULTS',
  to: '/en/adults',
  children: [{
    label: 'For Adults',
    to: '/en/adults'
  }, {
    label: 'Annual Programs',
    to: '/en/adults/annual-programs'
  }, {
    label: 'Core Courses',
    to: '/en/adults/core-courses'
  }, {
    label: 'Professional Development',
    to: '/en/adults/professional-development'
  }, {
    label: 'Creative Learning',
    to: '/en/adults/creative-learning'
  }]
}, {
  label: 'PARTNERSHIP',
  to: '/en/partnership',
  children: [{
    label: 'Get Involved',
    to: '/en/partnership'
  }, {
    label: 'Donate for Children',
    to: '/en/partnership/donate-for-children'
  }, {
    label: 'Scholarships Program',
    to: '/en/partnership/scholarships'
  }, {
    label: 'Institutional Partners',
    to: '/en/partnership/institutional-partners'
  }, {
    label: 'Become a Partner',
    to: '/en/partnership/become-a-partner'
  }]
}, {
  label: 'CONTACT',
  to: '/en/contact',
  children: [{
    label: 'Get In Touch',
    to: '/en/contact'
  }, {
    label: 'General Inquiry',
    to: '/en/contact#general-inquiry'
  }, {
    label: 'Become a Teacher',
    to: '/en/contact#become-a-teacher'
  }, {
    label: 'Volunteers',
    to: '/en/contact#volunteers'
  }, {
    label: 'Careers',
    to: '/en/contact#careers'
  }]
}];
export function Header() {
  const [open, setOpen] = useState(false);
  const [openSub, setOpenSub] = useState<string | null>(null);
  const location = useLocation();
  useEffect(() => {
    setOpen(false);
    setOpenSub(null);
  }, [location.pathname]);
  // Handle hash scroll for anchor links
  const handleHashScroll = (hash: string) => {
    if (hash) {
      setTimeout(() => {
        const element = document.querySelector(hash);
        if (element) {
          element.scrollIntoView({
            behavior: 'smooth',
            block: 'start'
          });
        }
      }, 100);
    }
  };
  return <header className="sticky top-0 z-50 bg-ivory/90 backdrop-blur border-b border-ink-900/5" data-id="element-534" data-mp="s8ybsashe5ux">
      <div className="max-w-container mx-auto px-5 md:px-8 lg:px-10 h-[90px] flex items-center justify-between gap-6" data-id="element-535" data-mp="x7i18l6a9zs1">
        <Link to="/en" className="flex-shrink-0" data-id="element-536" data-mp="3hvmkd58xrwla">
          <Logo data-id="element-537" data-mp="3hxh4ihcdvkob" />
        </Link>

        <nav className="hidden lg:flex items-center gap-7 text-[14px] font-semibold tracking-[0.1em]" data-id="element-538" data-mp="3htjmjz1jkz60">
          {navItems.map(item => {
          const hasChildren = !!item.children?.length;
          const isActiveSection = item.to === '/en' ? location.pathname === '/en' : location.pathname === item.to || location.pathname.startsWith(item.to + '/');
          if (!hasChildren) {
            return <NavLink key={item.to} to={item.to} end className={({
              isActive
            }) => `relative py-2 transition-colors ${isActive ? 'text-forest-700' : 'text-ink-700 hover:text-forest-700'}`} data-id="element-539" data-mp="jwwx2a3knqzo">
                  {({
                isActive
              }) => <>
                      {item.label}
                      {isActive && <motion.span layoutId="nav-underline" className="absolute left-0 right-0 -bottom-px h-0.5 bg-sand-400 rounded-full" data-id="element-540" data-mp="2qofk9opx6915" />}
                    </>}
                </NavLink>;
          }
          return <div key={item.to} className="relative" onMouseEnter={() => setOpenSub(item.label)} onMouseLeave={() => setOpenSub(null)} data-id="element-541" data-mp="2vag68fszljur">
                <Link to={item.to} className={`relative py-2 inline-flex items-center gap-1 transition-colors ${isActiveSection ? 'text-forest-700' : 'text-ink-700 hover:text-forest-700'}`} data-id="element-542" data-mp="34alf6udtwqb1">
                  {item.label}
                  <ChevronDownIcon size={12} strokeWidth={2} className={`transition-transform ${openSub === item.label ? 'rotate-180' : ''}`} data-id="element-543" data-mp="3e6y6xmptcu35" />
                  {isActiveSection && <motion.span layoutId="nav-underline" className="absolute left-0 right-4 -bottom-px h-0.5 bg-sand-400 rounded-full" data-id="element-544" data-mp="1bv3okod6ghzb" />}
                </Link>

                <AnimatePresence data-id="element-545" data-mp="1gtoffx6jhpb3">
                  {openSub === item.label && <motion.div initial={{
                opacity: 0,
                y: 4
              }} animate={{
                opacity: 1,
                y: 0
              }} exit={{
                opacity: 0,
                y: 4
              }} transition={{
                duration: 0.18,
                ease: [0.22, 1, 0.36, 1]
              }} className={`absolute top-full pt-3 ${item.label === 'CONTACT' ? 'right-0' : 'left-0'}`} data-id="element-546" data-mp="1gw16r0y6tc0t">
                      <div className="min-w-[240px] rounded-2xl bg-white border border-ink-900/5 shadow-card p-2" data-id="element-547" data-mp="2s7foiu7zajtp">
                        {item.children!.map(child => <NavLink key={child.to} to={child.to} end onClick={() => {
                    const hash = child.to.split('#')[1];
                    if (hash) handleHashScroll(`#${hash}`);
                  }} className="block px-4 py-2.5 rounded-xl text-[13px] font-medium uppercase tracking-[0.06em] transition-colors text-ink-700 hover:bg-sage-50 hover:text-forest-700" data-id="element-548" data-mp="2j56d824vymf9">
                            {child.label}
                          </NavLink>)}
                      </div>
                    </motion.div>}
                </AnimatePresence>
              </div>;
        })}
        </nav>

        <div className="flex items-center gap-3" data-id="element-549" data-mp="25zad8tkq3kit">
          <Link to="/en/waitlist" className="hidden md:inline-flex" data-id="element-550" data-mp="25ztmzn07z2lr">
            <Button variant="gold" size="sm" data-id="element-551" data-mp="21wxbshd0e8ru">
              JOIN
            </Button>
          </Link>
          <button type="button" className="lg:hidden inline-flex items-center justify-center w-10 h-10 rounded-full border border-ink-900/10 text-ink-900" onClick={() => setOpen(v => !v)} aria-label="Toggle menu" data-id="element-552" data-mp="1wzexebg831cg">
            {open ? <XIcon size={18} data-id="element-553" data-mp="1i97qmszkv6rl" /> : <MenuIcon size={18} data-id="element-554" data-mp="1iar8go0vtpvh" />}
          </button>
        </div>
      </div>

      <AnimatePresence data-id="element-555" data-mp="1e8nunsqqq971">
        {open && <motion.div initial={{
        opacity: 0,
        height: 0
      }} animate={{
        opacity: 1,
        height: 'auto'
      }} exit={{
        opacity: 0,
        height: 0
      }} transition={{
        duration: 0.25,
        ease: [0.22, 1, 0.36, 1]
      }} className="lg:hidden overflow-hidden border-t border-ink-900/5 bg-ivory" data-id="element-556" data-mp="1e9p2zpgdghl2">
            <div className="max-w-container mx-auto px-5 md:px-8 py-4 flex flex-col" data-id="element-557" data-mp="3pvzhm819f0yf">
              {navItems.map(item => {
            if (!item.children?.length) {
              return <NavLink key={item.to} to={item.to} end className={({
                isActive
              }) => `py-3 text-sm font-semibold tracking-wider border-b border-ink-900/5 ${isActive ? 'text-forest-700' : 'text-ink-900'}`} data-id="element-558" data-mp="2x8n2gixfhvf5">
                      {item.label}
                    </NavLink>;
            }
            const expanded = openSub === item.label;
            return <div key={item.to} className="border-b border-ink-900/5" data-id="element-559" data-mp="20x9er2xcnlad">
                    <button type="button" onClick={() => setOpenSub(expanded ? null : item.label)} className="w-full flex items-center justify-between py-3 text-sm font-semibold tracking-wider text-ink-900" data-id="element-560" data-mp="25vt0p3by0x2q">
                      {item.label}
                      <ChevronDownIcon size={14} strokeWidth={2} className={`transition-transform ${expanded ? 'rotate-180' : ''}`} data-id="element-561" data-mp="1i71fivwrtezg" />
                    </button>
                    <AnimatePresence data-id="element-562" data-mp="1r53n5ub0f5vp">
                      {expanded && <motion.div initial={{
                  opacity: 0,
                  height: 0
                }} animate={{
                  opacity: 1,
                  height: 'auto'
                }} exit={{
                  opacity: 0,
                  height: 0
                }} transition={{
                  duration: 0.2
                }} className="overflow-hidden" data-id="element-563" data-mp="1vyy3cnrep2q1">
                          <div className="flex flex-col border-l border-sand-300/60 pb-3 pl-4" data-id="element-564" data-mp="cz8onu1283ru">
                            {item.children.map(child => <NavLink key={child.to} to={child.to} end onClick={() => {
                      const hash = child.to.split('#')[1];
                      if (hash) handleHashScroll(`#${hash}`);
                    }} className="py-2 text-[13px] font-medium uppercase tracking-[0.06em] text-ink-700" data-id="element-565" data-mp="86fjx65lcvfr">
                                {child.label}
                              </NavLink>)}
                          </div>
                        </motion.div>}
                    </AnimatePresence>
                  </div>;
          })}
              <div className="pt-4" data-id="element-566" data-mp="3uhe91fv47n0x">
                <Link to="/en/waitlist" data-id="element-567" data-mp="3uifri5egnbso">
                  <Button variant="gold" className="w-full" data-id="element-568" data-mp="3buvs8dgnfpb">
                    JOIN
                  </Button>
                </Link>
              </div>
            </div>
          </motion.div>}
      </AnimatePresence>
    </header>;
}